import React from 'react';

import Button, { ButtonProps } from '@mui/material/Button';

const SmallButton = (props: ButtonProps) => {
  return (
    <Button
      {...props}
      variant="outlined"
      size="small"
      style={{
        padding: '1px 8px',
        fontWeight: 'bold',
        fontSize: '0.6em',
      }}
    />
  );
};

export default SmallButton;
